import * as React from "react";
import {none, Option, option} from "ts-option";
import MerchantBranchLocation from "../../../../model/merchant/MerchantBranchLocation";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect, Dispatch} from "react-redux";
import Merchant from "../../../../model/merchant/Merchant";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Loading from "../../../ui/loading/Loading";
import {SitesMap} from "../../../../store/reducer/site/SiteState";
import {OnSuccessData} from "../../../../store/action/actionHelpers";
import {fetchSite} from "../../../../store/action/site/site";
import Job from "../../../../model/job/Job";
import Lead from "../../../../model/lead/Lead";


interface ComponentProps {
	/**
	 * Job or Lead
	 */
	item: Option<Job | Lead>
}

interface ReduxProps {
	/**
	 * Branch addresses
	 */
	sites: SitesMap
	/**
	 * Merchants
	 */
	merchants: Option<Merchant[]>
}

interface DispatchProps {
	fetchSite: (siteId: string) => void
}

interface State {
	/**
	 * Preferred merchant branch location
	 */
	preferredMerchantBranchLocation: Option<MerchantBranchLocation>
}

type Props = ComponentProps & ReduxProps & DispatchProps

/**
 * Preferred merchant branch location display component
 */
class PreferredMerchantBranchLocationDisplayer extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {preferredMerchantBranchLocation: none};
		this.fetchMerchantBranchLocation = this.fetchMerchantBranchLocation.bind(this);
	}

	componentDidMount() {
		this.props.item.flatMap(j => j.preferredMerchantBranchLocationId.map(
			id => this.fetchMerchantBranchLocation(id, (pmbl) => this.props.fetchSite(pmbl.siteId))));
	}

	componentWillReceiveProps(nextProps: Props) {
		if(this.props.item.flatMap(j => j.preferredMerchantBranchLocationId).orNull !== nextProps.item.flatMap(j => j.preferredMerchantBranchLocationId).orNull) {
			nextProps.item.flatMap(j => j.preferredMerchantBranchLocationId.map(
				id => this.fetchMerchantBranchLocation(id, (pmbl) => this.props.fetchSite(pmbl.siteId))));
		}
	}

	render() {
		const merchants = this.props.merchants;
		const siteId: Option<string> = this.state.preferredMerchantBranchLocation.map(pmbl => pmbl.siteId);
		const merchantId = this.state.preferredMerchantBranchLocation.map(pmbl => pmbl.merchantId);
		const loading = <Loading isLoading={true} spinnerSize={32}/>;
		const empty = <></>;
		const site = siteId.map(sId => option(this.props.sites[sId]).map(s =>
			<>{s.data.address.displayName()}</>
		).getOrElse(loading)).getOrElse(empty);
		const merchantName = merchantId.map(mId => option(merchants.getOrElse([]).filter(m => m.id == mId)[0]).map(m =>
			<>{m.name}</>
		).getOrElse(loading)).getOrElse(empty);
		return (
			<InfoModule icon={Icon.Site} title={"PREFERRED BRANCH"}>
				{
					this.state.preferredMerchantBranchLocation.isDefined ?
						<>
							<div className="t-body">{this.state.preferredMerchantBranchLocation.get.name}</div>
							<div className="t-body">{merchantName}</div>
							<div className="t-body">{site}</div>
							<div className="t-body">{this.state.preferredMerchantBranchLocation.get.phone}</div>
							<div className="t-body">{this.state.preferredMerchantBranchLocation.get.email}</div>
						</>
						: <div className="t-body">N/A</div>
				}
			</InfoModule>
		);
	}

	/**
	 * Fetch preferred branch location by identifier
	 * @param preferredMerchantBranchLocationId
	 * @param onSuccess
	 */
	fetchMerchantBranchLocation(preferredMerchantBranchLocationId: string, onSuccess: OnSuccessData<MerchantBranchLocation>) {
		api.instance.merchantApi.getMerchantBranchLocationById(preferredMerchantBranchLocationId).then(
			(pmbl: MerchantBranchLocation) => {
				onSuccess(pmbl);
				this.setState({preferredMerchantBranchLocation: option(pmbl)})
			}).catch(
			(error) => {
				notifyBugsnagAndShowToast(error, "Preferred Branch");
			})
	}
}

function mapStateToProps(state: RootState) {
	const merchants = state.merchant.merchants;
	const sites = state.site.sitesMap;
	return {
		sites,
		merchants
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchSite: (siteId: string) => dispatch(fetchSite(siteId, () => {}, err => notifyBugsnagAndShowToast(err, "Fetch site")))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferredMerchantBranchLocationDisplayer)